export const sanitizeNationalNumber = (value) => {
  if (!value) {
    return '';
  }
  return value.replace(/[^\d]/g, '');
};

export const combineDialCodeAndNumber = (dialCode, rawNumber) => {
  const dialDigits = sanitizeNationalNumber(dialCode);
  const nationalDigits = sanitizeNationalNumber(rawNumber).replace(/^0+/, '');
  if (!dialDigits || !nationalDigits) {
    return '';
  }
  const combined = `${dialDigits}${nationalDigits}`;
  if (combined.length < 8 || combined.length > 15) {
    return '';
  }
  return `+${combined}`;
};

export const formatDisplayNumber = (dialCode, rawNumber) => {
  const digits = sanitizeNationalNumber(rawNumber);
  if (!digits) {
    return dialCode;
  }
  return `${dialCode} ${digits}`;
};
